import ChampionshipCode from '@/apps/ChampionshipCode'
import React from 'react'

const ChampionshipCodeBody = (): React.ReactElement => {
  return <ChampionshipCode />
}

export default ChampionshipCodeBody
